var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ModalAjoutProduits", {
        ref: "modalAjoutProduits",
        attrs: {
          commande: _vm.commande,
          idsFournisseursVerrouilles: _vm.idsFournisseursVerrouilles()
        },
        on: {
          "ajouter-articles": function($event) {
            return _vm.ajouterArticles($event)
          }
        }
      }),
      _c("ModalImpressionCommande", {
        ref: "modalImpressionCommande",
        attrs: {
          commande: _vm.commande,
          pasDEnvoi: !_vm.commandeEnCreationOuErreurMailNonTraitee()
        },
        on: {
          "commande-envoyee": function($event) {
            return _vm.chargerCommande(_vm.commande.id)
          }
        }
      }),
      _c("ModalSubstitutionArticle", {
        ref: "modalSubstitutionArticle",
        attrs: { idsBloques: _vm.idsFournisseursVerrouilles() },
        on: {
          "selection-article": function($event) {
            return _vm.substituerArticle($event)
          }
        }
      }),
      _c("ModalChoisirFournisseur", {
        ref: "modalChoisirFournisseur",
        attrs: {
          commande: _vm.commande,
          pasDEnvoi: !_vm.commandeEnCreationOuErreurMailNonTraitee()
        },
        on: {
          "commande-envoyee": function($event) {
            return _vm.initialiserCommande($event)
          }
        }
      }),
      _c("ModalAjoutProduitHM", {
        ref: "modalAjoutProduit",
        attrs: { paramModale: { modeAffichage: "ajoutProduit" } },
        on: {
          "produit-modifie": function($event) {
            return _vm.affecterNouveauProduitHM($event)
          }
        }
      }),
      _c("ModalEnvoiCommande", {
        ref: "modalEnvoiCommande",
        attrs: { commande: _vm.commande },
        on: {
          "commande-envoyee": function($event) {
            return _vm.chargerCommande(_vm.commande.id)
          }
        }
      }),
      _c("ModalRecetteEdition", {
        ref: "modalRecetteEdition",
        on: {
          "recette-enregistree": function($event) {
            return _vm.recetteEnregistree($event)
          },
          "recette-enregistree-modifiee": function($event) {
            return _vm.recetteEnregistreeModifiee($event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _c("div", { staticClass: "card table-scroll height-responsive-65" }, [
            _c(
              "div",
              { staticClass: "card-header flex-center-space-between" },
              [
                _c("div", { staticClass: "flex-start" }, [
                  _c("span", [_vm._v(_vm._s(_vm.commande.nom))])
                ]),
                _vm.inventaireOuvert
                  ? _c("span", { staticClass: "text-warning" }, [
                      _c("i", {
                        staticClass: "fas fa-exclamation-triangle text-warning"
                      }),
                      _vm._v(" Inventaire en cours ")
                    ])
                  : _vm._e(),
                _vm.enAttenteDeValidation
                  ? _c("span", { staticClass: "text-warning" }, [
                      _c("i", {
                        staticClass: "fas fa-exclamation-triangle text-warning"
                      }),
                      _vm._v(" En attente de validation par le gestionnaire ")
                    ])
                  : _vm._e(),
                _vm.valideeParGestionnaire
                  ? _c("span", { staticClass: "text-success" }, [
                      _c("i", {
                        staticClass: "fas fa-info-circle text-success"
                      }),
                      _vm._v(" Validée par le gestionnaire ")
                    ])
                  : _vm._e(),
                _vm.tarifsRecalcules
                  ? _c("span", { staticClass: "text-warning" }, [
                      _c("i", {
                        staticClass: "fas fa-exclamation-triangle text-warning"
                      }),
                      _vm._v(" Tarifs obsolètes mis à jour ")
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "flex-end" }, [
                  _c("span", { staticClass: "ml-5" }, [
                    _vm._v(
                      "Lignes de commande : " +
                        _vm._s(_vm.nbLignes(_vm.commande)) +
                        " / " +
                        _vm._s(_vm.lignesAAfficher().length)
                    )
                  ]),
                  _c("span", { staticClass: "ml-5" }, [
                    _vm._v(
                      "Fournisseurs différents : " +
                        _vm._s(_vm.nbFournisseurs(_vm.commande))
                    )
                  ]),
                  _c("span", { staticClass: "ml-5" }, [
                    _vm._v(" Total HT : "),
                    _c("em", [
                      _vm.totalPCB(_vm.donneesInitiales) !== 0 &&
                      _vm.totalPCB(_vm.commande) !==
                        _vm.totalPCB(_vm.donneesInitiales)
                        ? _c("span", [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm._f("afficherPrix2")(
                                    _vm.totalPCB(_vm.donneesInitiales)
                                  )
                                ) +
                                ") "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "span",
                      {
                        class: [
                          {
                            "bg-success p-1 pl-2 pr-2":
                              _vm.totalPCB(_vm.donneesInitiales) !== 0 &&
                              _vm.totalPCB(_vm.commande) <
                                _vm.totalPCB(_vm.donneesInitiales)
                          },
                          {
                            "bg-warning p-1 pl-2 pr-2":
                              _vm.totalPCB(_vm.donneesInitiales) !== 0 &&
                              _vm.totalPCB(_vm.commande) >
                                _vm.totalPCB(_vm.donneesInitiales)
                          }
                        ]
                      },
                      [
                        _c("b", { staticStyle: { color: "inherit" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("afficherPrix2")(
                                _vm.totalPCB(_vm.commande)
                              )
                            ) + " "
                          )
                        ]),
                        _vm.totalPCB(_vm.donneesInitiales) !== 0 &&
                        _vm.totalPCB(_vm.commande) >
                          _vm.totalPCB(_vm.donneesInitiales)
                          ? _c("i", {
                              staticClass: "fas fa-arrow-up",
                              staticStyle: { color: "inherit" }
                            })
                          : _vm._e(),
                        _vm.totalPCB(_vm.donneesInitiales) !== 0 &&
                        _vm.totalPCB(_vm.commande) <
                          _vm.totalPCB(_vm.donneesInitiales)
                          ? _c("i", {
                              staticClass: "fas fa-arrow-down",
                              staticStyle: { color: "inherit" }
                            })
                          : _vm._e()
                      ]
                    )
                  ]),
                  _c("span", { staticClass: "ml-5" }, [
                    _vm._v(
                      "Total TTC : " +
                        _vm._s(
                          _vm._f("afficherPrix2")(_vm.totalTTC(_vm.commande))
                        )
                    )
                  ])
                ])
              ]
            ),
            _c(
              "table",
              {
                staticClass:
                  "table table-bordered table-sm text-center table-header-secondary"
              },
              [
                _c("colgroup", [
                  _c("col", { attrs: { width: "40" } }),
                  _c("col"),
                  _c("col", { attrs: { width: "180" } }),
                  _c("col", { attrs: { width: "75" } }),
                  _c("col", { attrs: { width: "140" } }),
                  _c("col", { attrs: { width: "90" } }),
                  _vm.commandeDepuisMenu()
                    ? _c("col", { attrs: { width: "90" } })
                    : _vm._e(),
                  _c("col", { attrs: { width: "150" } }),
                  _c("col", { attrs: { width: "110" } }),
                  _c("col", { attrs: { width: "70" } }),
                  _c("col", { attrs: { width: "90" } }),
                  _c("col", { attrs: { width: "34" } })
                ]),
                _c("thead", [
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("faId", true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.afficheIconeTri("faId") ? "Fa." : "Fam.")
                      ),
                      _vm.afficheIconeTri("faId")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "aligner-gauche watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("designation")
                        }
                      }
                    },
                    [
                      _vm._v("Désignation"),
                      _vm.afficheIconeTri("designation")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("foId", true)
                        }
                      }
                    },
                    [
                      _vm._v("Fournisseur"),
                      _vm.afficheIconeTri("foId")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("Ref")
                        }
                      }
                    },
                    [
                      _vm._v("Réf."),
                      _vm.afficheIconeTri("Ref")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("marque")
                        }
                      }
                    },
                    [
                      _vm._v("Marque"),
                      _vm.afficheIconeTri("marque")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("qStock", true)
                        }
                      }
                    },
                    [
                      _vm._v("Qté. stock"),
                      _vm.afficheIconeTri("qStock")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _vm.commandeDepuisMenu()
                    ? _c(
                        "th",
                        {
                          staticClass: "watchMe",
                          on: {
                            click: function($event) {
                              return _vm.trierListe("qBesoin", true)
                            }
                          }
                        },
                        [
                          _vm._v("Qté. besoin"),
                          _vm.afficheIconeTri("qBesoin")
                            ? _c("i", { class: _vm.iconeSensTri })
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("qDem", true)
                        }
                      }
                    },
                    [
                      _vm._v("Qté. demandée"),
                      _vm.afficheIconeTri("qDem")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("qPCB", true)
                        }
                      }
                    },
                    [
                      _vm._v("Qté. PCB (PCB)"),
                      _vm.afficheIconeTri("qPCB")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("pu", true)
                        }
                      }
                    },
                    [
                      _vm._v("PU HT"),
                      _vm.afficheIconeTri("pu")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "watchMe",
                      on: {
                        click: function($event) {
                          return _vm.trierListe("totalht", true)
                        }
                      }
                    },
                    [
                      _vm._v("Total HT"),
                      _vm.afficheIconeTri("totalht")
                        ? _c("i", { class: _vm.iconeSensTri })
                        : _vm._e()
                    ]
                  ),
                  _c("th")
                ])
              ]
            ),
            _c("div", { staticClass: "table-body" }, [
              _c(
                "table",
                { staticClass: "table table-bordered table-sm text-center" },
                [
                  _c("colgroup", [
                    _c("col", { attrs: { width: "40" } }),
                    _c("col"),
                    _c("col", { attrs: { width: "180" } }),
                    _c("col", { attrs: { width: "75" } }),
                    _c("col", { attrs: { width: "140" } }),
                    _c("col", { attrs: { width: "90" } }),
                    _vm.commandeDepuisMenu()
                      ? _c("col", { attrs: { width: "90" } })
                      : _vm._e(),
                    _c("col", { attrs: { width: "150" } }),
                    _c("col", { attrs: { width: "110" } }),
                    _c("col", { attrs: { width: "70" } }),
                    _c("col", { attrs: { width: "90" } }),
                    _c("col", { attrs: { width: "29" } })
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.lignesFiltreesTrieesAAfficher, function(
                      ligne,
                      iLigne
                    ) {
                      return _c(
                        "tr",
                        {
                          key: iLigne,
                          class: [
                            {
                              "ligne-selectionnee":
                                _vm.idLignePourSelection(ligne) ===
                                _vm.idLigneSelectionnee
                            },
                            { "ligne-modifiee": _vm.estModifiee(ligne) },
                            { "ligne-supprimee": ligne.deleted },
                            {
                              "ligne-desactivee":
                                _vm.commandeFournisseurEnvoyee(ligne.foId) ||
                                _vm.commandeFournisseurReceptionnee(ligne.foId)
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.selectionnerLigneCommande(ligne)
                            }
                          }
                        },
                        [
                          ligne.pId
                            ? [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.codeFamille(ligne.faId)))
                                ]),
                                _c("td", { staticClass: "aligner-gauche" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.ligneDesignation(ligne)) +
                                      " "
                                  ),
                                  !ligne.ingId
                                    ? _c(
                                        "em",
                                        { staticClass: "warning ml-2" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-exclamation-triangle ligne-modifiee"
                                          }),
                                          _vm._v(" Produit sans ingrédient ")
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _c(
                                  "td",
                                  {
                                    class: [
                                      "input",
                                      { "bg-error": !ligne.foId }
                                    ]
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "flex-space-between" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nomFournisseur(ligne.foId)
                                            )
                                          )
                                        ]),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.commandeFournisseurEnCreation(
                                                  ligne.foId
                                                ) || _vm.valideeParGestionnaire
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.showSubstitutionArticle(
                                                  ligne
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-exchange-alt"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c("td", [_vm._v(_vm._s(ligne.Ref))]),
                                _c("td", [_vm._v(_vm._s(ligne.marque))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("afficherArrondi")(
                                        ligne.qStock || 0
                                      )
                                    ) +
                                      " " +
                                      _vm._s(ligne.uc)
                                  )
                                ]),
                                _vm.commandeDepuisMenu()
                                  ? _c("td", [
                                      ligne.qBesoin
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("afficherArrondi")(
                                                  ligne.qBesoin
                                                )
                                              ) + " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "text-warning": !_vm.ucIdentiques(
                                                    _vm.ucBesoin(ligne),
                                                    ligne.uc
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.ucBesoin(ligne))
                                                )
                                              ]
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v("0 "),
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "text-warning": !_vm.ucIdentiques(
                                                    _vm.ucBesoin(ligne),
                                                    ligne.uc
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.ucBesoin(ligne))
                                                )
                                              ]
                                            )
                                          ])
                                    ])
                                  : _vm._e(),
                                _c("td", { staticClass: "input" }, [
                                  _vm.commandeFournisseurEnCreation(
                                    ligne.foId
                                  ) && !_vm.valideeParGestionnaire
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "flex-center-space-between"
                                        },
                                        [
                                          ligne.uModifiees
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-exclamation-triangle error"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "flex-end h-100 p-0 m-0"
                                            },
                                            [
                                              _c("InputNumber", {
                                                ref: "inputNumber",
                                                refInFor: true,
                                                staticClass: "form-control",
                                                attrs: {
                                                  "data-lignepid": ligne.pId,
                                                  typeFiltre: "quantite",
                                                  zeroSiVide: "1",
                                                  fixBlur: true
                                                },
                                                on: {
                                                  move: function($event) {
                                                    return _vm.deplacerSelectionLigneCommande(
                                                      $event
                                                    )
                                                  },
                                                  focus: function($event) {
                                                    return _vm.selectionnerLigneCommandeInput(
                                                      ligne
                                                    )
                                                  },
                                                  save: function($event) {
                                                    return _vm.qteDemChangee(
                                                      ligne,
                                                      $event
                                                    )
                                                  },
                                                  blur: function($event) {
                                                    return _vm.qteDemChangee(
                                                      ligne,
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: ligne.qDem,
                                                  callback: function($$v) {
                                                    _vm.$set(ligne, "qDem", $$v)
                                                  },
                                                  expression: "ligne.qDem"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    "input-group-text",
                                                    {
                                                      "text-warning": !_vm.ucIdentiques(
                                                        _vm.ucBesoin(ligne),
                                                        ligne.uc
                                                      )
                                                    }
                                                  ]
                                                },
                                                [_vm._v(_vm._s(ligne.uc))]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "input-group-btn" },
                                            [
                                              ligne.uModifiees
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-sm",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.effacerAlerteRecalcul(
                                                            ligne
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-check"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("afficherArrondi")(
                                                ligne.qDem
                                              )
                                            ) +
                                            " " +
                                            _vm._s(ligne.uc) +
                                            " "
                                        )
                                      ])
                                ]),
                                _c(
                                  "td",
                                  {
                                    class: [
                                      {
                                        "bg-warning":
                                          ligne.qDem !== _vm.qtePcb(ligne)
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("afficherArrondi")(
                                          _vm.qtePcb(ligne)
                                        )
                                      ) +
                                        " " +
                                        _vm._s(ligne.uc) +
                                        " "
                                    ),
                                    ligne.pcb
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("afficherArrondi")(
                                                  ligne.pcb
                                                )
                                              ) +
                                              ")"
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c("td", { staticClass: "aligner-droite" }, [
                                  ligne.pu
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("afficherPrix")(ligne.pu)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticClass: "aligner-droite",
                                    class: [
                                      {
                                        "bg-warning":
                                          ligne.qDem !== _vm.qtePcb(ligne)
                                      }
                                    ]
                                  },
                                  [
                                    ligne.pu
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("afficherPrix2")(
                                                _vm.ligneTotalPCB(ligne)
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c("td", { staticClass: "input" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger btn-sm ml-0",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          !_vm.commandeFournisseurEnCreation(
                                            ligne.foId
                                          ) || _vm.valideeParGestionnaire
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.supprimerLigne(ligne)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-trash" })]
                                  )
                                ])
                              ]
                            : ligne.recIngId &&
                              _vm.getProduits.find(function(p) {
                                return p.ingredientId === ligne.recIngId
                              })
                            ? [
                                _c(
                                  "td",
                                  {
                                    class: [
                                      "aligner-gauche",
                                      {
                                        "bg-error":
                                          _vm.idLignePourSelection(ligne) !==
                                          _vm.idLigneSelectionnee
                                      },
                                      {
                                        "text-error":
                                          _vm.idLignePourSelection(ligne) ===
                                          _vm.idLigneSelectionnee
                                      }
                                    ],
                                    attrs: {
                                      colspan: _vm.commandeDepuisMenu()
                                        ? 12
                                        : 11
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Sélection automatique impossible pour l'ingrédient : \"" +
                                        _vm._s(_vm.ligneDesignation(ligne)) +
                                        '" - ' +
                                        _vm._s(
                                          _vm._f("afficherArrondi")(
                                            ligne.qBesoin
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          ligne.utilisations &&
                                            ligne.utilisations[0] &&
                                            ligne.utilisations[0].uc
                                        ) +
                                        "    -   Sélectionnez un produit manuellement, puis renseigner la quantité : "
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary btn-sm ml-3",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.commandeFournisseurEnCreation(
                                            ligne.foId
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showSubstitutionArticle(
                                              ligne
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-exchange-alt"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : ligne.recIngId
                            ? [
                                _c(
                                  "td",
                                  {
                                    class: [
                                      "aligner-gauche",
                                      {
                                        "bg-error":
                                          _vm.idLignePourSelection(ligne) !==
                                          _vm.idLigneSelectionnee
                                      },
                                      {
                                        "text-error":
                                          _vm.idLignePourSelection(ligne) ===
                                          _vm.idLigneSelectionnee
                                      }
                                    ],
                                    attrs: {
                                      colspan: _vm.commandeDepuisMenu()
                                        ? 12
                                        : 11
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Aucun prix disponible pour l'ingrédient : " +
                                        _vm._s(_vm.ligneDesignation(ligne)) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("afficherArrondi")(
                                            ligne.qBesoin
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          ligne.utilisations &&
                                            ligne.utilisations[0] &&
                                            ligne.utilisations[0].uc
                                        ) +
                                        "    -   Créez un produit hors marché : "
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.commandeFournisseurEnCreation(
                                            ligne.foId
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showAjoutProduitHM(ligne)
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fas fa-plus" })]
                                    )
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "td",
                                  {
                                    class: [
                                      "aligner-gauche",
                                      {
                                        "bg-error":
                                          _vm.idLignePourSelection(ligne) !==
                                          _vm.idLigneSelectionnee
                                      },
                                      {
                                        "text-error":
                                          _vm.idLignePourSelection(ligne) ===
                                          _vm.idLigneSelectionnee
                                      }
                                    ],
                                    attrs: {
                                      colspan: _vm.commandeDepuisMenu()
                                        ? 12
                                        : 11
                                    }
                                  },
                                  [
                                    _vm._v(
                                      ' Ingrédient indisponible, veuillez cliquer sur le bouton "Recalculer besoins" : ' +
                                        _vm._s(_vm.ligneDesignation(ligne)) +
                                        " (Aucune cotation disponible) - " +
                                        _vm._s(
                                          _vm._f("afficherArrondi")(
                                            ligne.qBesoin
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          ligne.utilisations &&
                                            ligne.utilisations[0] &&
                                            ligne.utilisations[0].uc
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "flex-center-space-between" }, [
            _vm.commandeDepuisMenu()
              ? _c(
                  "div",
                  {
                    staticClass: "card table-scroll height-responsive-35 mr-1"
                  },
                  [
                    _c("div", { staticClass: "card-header" }, [
                      _vm.ligneSelectionnee
                        ? _c("span", [
                            _vm._v(
                              'Recettes contenant le produit "' +
                                _vm._s(
                                  _vm.ligneDesignation(_vm.ligneSelectionnee)
                                ) +
                                '"'
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "Cliquez sur une ligne produit pour voir les recettes correspondantes"
                            )
                          ])
                    ]),
                    _vm._m(0),
                    _c("div", { staticClass: "table-body" }, [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-bordered table-sm text-center"
                        },
                        [
                          _vm._m(1),
                          _vm.ligneSelectionnee
                            ? _c(
                                "tbody",
                                _vm._l(
                                  _vm.ligneSelectionnee.utilisations,
                                  function(utilisation, iUtilisation) {
                                    return _c(
                                      "tr",
                                      {
                                        key: iUtilisation,
                                        class: [
                                          {
                                            "ligne-selectionnee":
                                              _vm.idUtilisationPourSelection(
                                                utilisation
                                              ) ===
                                              _vm.idUtilisationSelectionnee
                                          },
                                          {
                                            "ligne-modifiee":
                                              utilisation.recetteEnregistree !=
                                                null ||
                                              utilisation.quantiteEnregistree !=
                                                null ||
                                              utilisation.ucEnregistree !=
                                                null ||
                                              utilisation.effectifsEnregistres !=
                                                null
                                          },
                                          {
                                            "ligne-supprimee":
                                              !utilisation.recette ||
                                              !utilisation.quantite
                                          },
                                          {
                                            "ligne-verrouillee":
                                              _vm.commandeFournisseurEnvoyee(
                                                _vm.ligneSelectionnee.foId
                                              ) ||
                                              _vm.commandeFournisseurReceptionnee(
                                                _vm.ligneSelectionnee.foId
                                              )
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            return _vm.selectionnerUtilisation(
                                              utilisation
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "td",
                                          { staticClass: "aligner-gauche" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "flex-center-space-between"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  [
                                                    utilisation.recette
                                                      .estUneDeclinaison &&
                                                    !utilisation.recette
                                                      .estDeclinaisonPersonnalisee
                                                      ? _c("i", {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value: {
                                                                content:
                                                                  "Configuration de recette non vérifiée",
                                                                placement: "top"
                                                              },
                                                              expression:
                                                                "{ content: 'Configuration de recette non vérifiée', placement: 'top' }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "fas fa-exclamation-triangle text-warning"
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "RecettePopUpIngredients",
                                                      {
                                                        attrs: {
                                                          estLien: true,
                                                          recetteId:
                                                            utilisation.recette
                                                              .id,
                                                          recetteNom:
                                                            utilisation.recette
                                                              .nom
                                                        },
                                                        on: {
                                                          "recette-enregistree": function(
                                                            $event
                                                          ) {
                                                            return _vm.recetteEnregistree(
                                                              $event
                                                            )
                                                          },
                                                          "recette-enregistree-modifiee": function(
                                                            $event
                                                          ) {
                                                            return _vm.recetteEnregistreeModifiee(
                                                              $event
                                                            )
                                                          }
                                                        }
                                                      }
                                                    ),
                                                    utilisation.recetteEnregistree !=
                                                    null
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "ligne-supprimee"
                                                          },
                                                          [
                                                            _vm._v(" ("),
                                                            utilisation
                                                              .recetteEnregistree
                                                              .estUneDeclinaison &&
                                                            !utilisation
                                                              .recetteEnregistree
                                                              .estDeclinaisonPersonnalisee
                                                              ? _c("i", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "tooltip",
                                                                      rawName:
                                                                        "v-tooltip",
                                                                      value: {
                                                                        content:
                                                                          "Configuration de recette non vérifiée",
                                                                        placement:
                                                                          "top"
                                                                      },
                                                                      expression:
                                                                        "{ content: 'Configuration de recette non vérifiée', placement: 'top' }"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "fas fa-exclamation-triangle text-warning"
                                                                })
                                                              : _vm._e(),
                                                            _c(
                                                              "RecettePopUpIngredients",
                                                              {
                                                                attrs: {
                                                                  estLien: true,
                                                                  recetteId:
                                                                    utilisation
                                                                      .recetteEnregistree
                                                                      .id,
                                                                  recetteNom:
                                                                    utilisation
                                                                      .recetteEnregistree
                                                                      .nom
                                                                },
                                                                on: {
                                                                  "recette-enregistree": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.recetteEnregistree(
                                                                      $event
                                                                    )
                                                                  },
                                                                  "recette-enregistree-modifiee": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.recetteEnregistreeModifiee(
                                                                      $event
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            ),
                                                            _vm._v(") ")
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                !_vm.ligneSelectionnee.pId
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "text-error",
                                                        attrs: { href: "" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.corriger(
                                                              utilisation
                                                                .recette.id,
                                                              _vm
                                                                .ligneSelectionnee
                                                                .recIngId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Corriger")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("td", [
                                          _vm._v(_vm._s(utilisation.structure))
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatHumanDateAvecSlashes(
                                                utilisation.dateConsommation
                                              )
                                            )
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(utilisation.service))
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("afficherArrondi")(
                                                  utilisation.quantite
                                                )
                                              ) +
                                              " " +
                                              _vm._s(utilisation.uc) +
                                              " "
                                          ),
                                          utilisation.quantiteEnregistree !=
                                          null
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "ligne-supprimee"
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm._f(
                                                          "afficherArrondi"
                                                        )(
                                                          utilisation.quantiteEnregistree
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        utilisation.ucEnregistree
                                                      ) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(utilisation.effectifs) +
                                              " "
                                          ),
                                          utilisation.effectifsEnregistres !=
                                          null
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "ligne-supprimee"
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        utilisation.effectifsEnregistres
                                                      ) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatHumanDateAvecSlashes(
                                                utilisation.dateLivraisonSouhaitee
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "card table-scroll height-responsive-35",
                class: { "ml-1": _vm.commandeDepuisMenu() }
              },
              [
                _c(
                  "div",
                  { staticClass: "card-header flex-center-space-between" },
                  [
                    _c("span", [
                      _vm._v("Commandes fournisseurs à envoyer / réceptionner")
                    ]),
                    _c("span", [
                      _c(
                        "label",
                        { staticClass: "label-checkbox mt-1" },
                        [
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v("Filtrer selon le fournisseur sélectionné")
                          ]),
                          _c("ToggleButton", {
                            staticClass: "ml-2 mt-1",
                            attrs: {
                              color: {
                                checked: "#16D39A",
                                unchecked: "#CCCCCC"
                              },
                              height: 12,
                              width: 20
                            },
                            on: {
                              change: function($event) {
                                return _vm.activerFiltreLignesSurFournisseurs()
                              }
                            },
                            model: {
                              value: _vm.filtrerLignesSurFournisseur,
                              callback: function($$v) {
                                _vm.filtrerLignesSurFournisseur = $$v
                              },
                              expression: "filtrerLignesSurFournisseur"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-bordered table-sm text-center table-header-secondary"
                  },
                  [
                    _vm._m(2),
                    _c("thead", [
                      _c("th", { staticClass: "aligner-gauche" }, [
                        _vm._v("Fournisseur")
                      ]),
                      _c("th", [_vm._v("Lignes")]),
                      _c("th", [_vm._v("Bon comm.")]),
                      _c("th", [_vm._v("Livraison")]),
                      _c("th", [_vm._v("Franco HT")]),
                      _c("th", [_vm._v("Total HT")]),
                      _c("th", { staticClass: "aligner-gauche pl-1" }, [
                        _vm.commandeEnCreationOuErreurMailNonTraitee()
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm ml-0",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.genererBdC()
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-envelope" })]
                            )
                          : _vm._e(),
                        _vm.commandeEnCreationOuErreurMailNonTraitee()
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.ouvrirEnvoiSansMail()
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-phone" })]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                ),
                _c("div", { staticClass: "table-body" }, [
                  _c(
                    "table",
                    {
                      staticClass: "table table-bordered table-sm text-center"
                    },
                    [
                      _vm._m(3),
                      _c(
                        "tbody",
                        _vm._l(_vm.fournisseursAAfficher, function(
                          fournisseur,
                          iFournisseur
                        ) {
                          return _c(
                            "tr",
                            {
                              key: iFournisseur,
                              class: [
                                {
                                  "ligne-selectionnee":
                                    fournisseur.fournisseurId ===
                                    _vm.idFournisseurSelectionne
                                },
                                {
                                  "ligne-modifiee": _vm.fournisseurEstModifie(
                                    fournisseur
                                  )
                                },
                                {
                                  "ligne-supprimee": !_vm.nbLignes(
                                    _vm.commande,
                                    fournisseur.fournisseurId
                                  )
                                },
                                {
                                  "ligne-desactivee": _vm.commandeFournisseurReceptionnee(
                                    fournisseur.fournisseurId
                                  )
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.selectionnerLigneFournisseur(
                                    fournisseur.fournisseurId
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "td",
                                {
                                  class: [
                                    "aligner-gauche",
                                    {
                                      "text-success": _vm.commandeFournisseurEnvoyee(
                                        fournisseur.fournisseurId
                                      )
                                    }
                                  ]
                                },
                                [
                                  _vm.commandeFournisseurEnCreation(
                                    fournisseur.fournisseurId
                                  )
                                    ? _c("i", {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content:
                                                "Commande en cours d'élaboration"
                                            },
                                            expression:
                                              "{ content: 'Commande en cours d\\'élaboration'}"
                                          }
                                        ],
                                        staticClass: "fas fa-shopping-cart"
                                      })
                                    : _vm._e(),
                                  _vm.commandeFournisseurEnvoyee(
                                    fournisseur.fournisseurId
                                  )
                                    ? _c("i", {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content:
                                                "Commande envoyée au fournisseur, en attente de livraison"
                                            },
                                            expression:
                                              "{ content: 'Commande envoyée au fournisseur, en attente de livraison'}"
                                          }
                                        ],
                                        staticClass:
                                          "fas fa-shipping-fast ligne-modifiee"
                                      })
                                    : _vm._e(),
                                  _vm.commandeFournisseurReceptionnee(
                                    fournisseur.fournisseurId
                                  )
                                    ? _c("i", {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content: "Commande réceptionnée"
                                            },
                                            expression:
                                              "{ content: 'Commande réceptionnée'}"
                                          }
                                        ],
                                        staticClass:
                                          "fas fa-boxes ligne-modifiee"
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.nomFournisseur(
                                          fournisseur.fournisseurId
                                        )
                                      ) +
                                      " "
                                  ),
                                  _vm.commandeFournisseurEnvoyeeManuellement(
                                    fournisseur.fournisseurId
                                  )
                                    ? _c("em", [
                                        _vm.commandeFournisseurEnErreurMail(
                                          fournisseur.fournisseurId
                                        )
                                          ? _c("span", [
                                              _vm._v(
                                                " (Erreur de mail, traitée manuellement le " +
                                                  _vm._s(
                                                    _vm.formatHumanDateAvecSlashes(
                                                      fournisseur.dateEnvoiManuel
                                                    )
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                " (Envoyée manuellement le " +
                                                  _vm._s(
                                                    _vm.formatHumanDateAvecSlashes(
                                                      fournisseur.dateEnvoiManuel
                                                    )
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                      ])
                                    : _vm.commandeFournisseurEnErreurMail(
                                        fournisseur.fournisseurId
                                      )
                                    ? _c("em", { staticClass: "error ml-2" }, [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle ligne-modifiee"
                                        }),
                                        _vm._v(" Erreur d'envoi du mail ")
                                      ])
                                    : _vm._e(),
                                  _vm.estAttenteValidationCommande &&
                                  _vm.commandeFournisseurInitialeValidee(
                                    fournisseur.fournisseurId
                                  )
                                    ? _c("em", [_vm._m(4, true)])
                                    : _vm._e()
                                ]
                              ),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.nbLignes(
                                      _vm.commande,
                                      fournisseur.fournisseurId
                                    )
                                  )
                                )
                              ]),
                              _c("td", { staticClass: "input" }, [
                                _vm.commandeFournisseurEnCreation(
                                  fournisseur.fournisseurId
                                ) &&
                                _vm.nbLignes(
                                  _vm.commande,
                                  fournisseur.fournisseurId
                                )
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: fournisseur.bonDeCommande,
                                          expression:
                                            "fournisseur.bonDeCommande",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "fourn" + fournisseur.fournisseurId,
                                        type: "text",
                                        maxlength: "80"
                                      },
                                      domProps: {
                                        value: fournisseur.bonDeCommande
                                      },
                                      on: {
                                        focus: function($event) {
                                          return $event.target.select()
                                        },
                                        keyup: function($event) {
                                          return _vm.deplacerSelectionFournisseur(
                                            $event
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            fournisseur,
                                            "bonDeCommande",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    })
                                  : _c("span", [
                                      _vm._v(_vm._s(fournisseur.bonDeCommande))
                                    ])
                              ]),
                              _c(
                                "td",
                                { staticClass: "input" },
                                [
                                  _vm.commandeFournisseurEnCreation(
                                    fournisseur.fournisseurId
                                  ) &&
                                  _vm.nbLignes(
                                    _vm.commande,
                                    fournisseur.fournisseurId
                                  )
                                    ? _c("v-date-picker", {
                                        staticClass: "date-picker",
                                        attrs: {
                                          attributes: _vm.attributsDPsCommande(
                                            fournisseur.fournisseurId
                                          ),
                                          popover: { visibility: "click" }
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.setDateLivraisonSouhaitee(
                                              fournisseur.fournisseurId,
                                              $event
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var inputValue = ref.inputValue
                                                var inputEvents =
                                                  ref.inputEvents
                                                return [
                                                  _c(
                                                    "input",
                                                    _vm._g(
                                                      {
                                                        class: [
                                                          "form-control",
                                                          {
                                                            incorrect: !fournisseur.dateLivraisonSouhaitee
                                                          }
                                                        ],
                                                        domProps: {
                                                          value: inputValue
                                                            ? inputValue
                                                            : "Date..."
                                                        },
                                                        on: {
                                                          focus: function(
                                                            $event
                                                          ) {
                                                            return _vm.selectionnerFournisseur(
                                                              fournisseur.fournisseurId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      inputEvents
                                                    )
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value:
                                            fournisseur.dateLivraisonSouhaitee,
                                          callback: function($$v) {
                                            _vm.$set(
                                              fournisseur,
                                              "dateLivraisonSouhaitee",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "fournisseur.dateLivraisonSouhaitee"
                                        }
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.commandeFournisseurReceptionnee(
                                              fournisseur.fournisseurId
                                            )
                                              ? _vm.formatHumanDateAvecSlashes(
                                                  fournisseur.dateLivraison
                                                )
                                              : _vm.formatHumanDateAvecSlashes(
                                                  fournisseur.dateLivraisonSouhaitee
                                                )
                                          )
                                        )
                                      ])
                                ],
                                1
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "aligner-droite",
                                  class: [
                                    {
                                      "bg-warning":
                                        _vm.totalPCB(
                                          _vm.commande,
                                          fournisseur.fournisseurId
                                        ) <
                                        _vm.francoFournisseur(
                                          fournisseur.fournisseurId
                                        )
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.francoFournisseur(
                                        fournisseur.fournisseurId
                                      )
                                    ) + " €"
                                  )
                                ]
                              ),
                              _c("td", { staticClass: "aligner-droite" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("afficherPrix2")(
                                      _vm.totalPCB(
                                        _vm.commande,
                                        fournisseur.fournisseurId
                                      )
                                    )
                                  )
                                )
                              ]),
                              _c("td", { staticClass: "input" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary btn-sm ml-0",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.nbLignes(
                                          _vm.commande,
                                          fournisseur.fournisseurId
                                        ) === 0 ||
                                        (_vm.estAttenteValidationCommande &&
                                          !_vm.valideeParGestionnaire)
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.envoyerBdCParMail(
                                          fournisseur.fournisseurId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas",
                                      class: _vm.commandeFournisseurEnCreationOuErreurMailNonTraitee(
                                        fournisseur.fournisseurId
                                      )
                                        ? /*'fa-paper-plane'*/ "fa-envelope"
                                        : "fa-print"
                                    })
                                  ]
                                ),
                                _vm.commandeFournisseurEnCreationOuErreurMailNonTraitee(
                                  fournisseur.fournisseurId
                                )
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: {
                                          type: "button",
                                          disabled:
                                            _vm.nbLignes(
                                              _vm.commande,
                                              fournisseur.fournisseurId
                                            ) === 0 ||
                                            (_vm.estAttenteValidationCommande &&
                                              !_vm.valideeParGestionnaire)
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.envoyerBdCSansMail(
                                              fournisseur.fournisseurId
                                            )
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fas fa-phone" })]
                                    )
                                  : _vm.commandeFournisseurEnvoyee(
                                      fournisseur.fournisseurId
                                    )
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.ouvrirDetailCommandeFournisseur(
                                              fournisseur.fournisseurId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-dolly-flatbed"
                                        })
                                      ]
                                    )
                                  : _vm.commandeFournisseurReceptionnee(
                                      fournisseur.fournisseurId
                                    )
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.ouvrirDetailCommandeFournisseur(
                                              fournisseur.fournisseurId
                                            )
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fas fa-eye" })]
                                    )
                                  : _vm._e(),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger btn-sm",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        !_vm.commandeFournisseurEnCreationOuErreurMailNonTraitee(
                                          fournisseur.fournisseurId
                                        ) ||
                                        _vm.nbLignes(
                                          _vm.commande,
                                          fournisseur.fournisseurId
                                        ) === 0 ||
                                        _vm.valideeParGestionnaire
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.supprimerFournisseur(
                                          fournisseur.fournisseurId
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-trash" })]
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticClass:
          "table table-bordered table-sm text-center table-header-secondary"
      },
      [
        _c("colgroup", [
          _c("col"),
          _c("col", {
            staticClass:
              "col-fixed-width-100-sm col-fixed-width-200-lg col-fixed-width-300-xl"
          }),
          _c("col", { attrs: { width: "90" } }),
          _c("col", { attrs: { width: "90" } }),
          _c("col", { attrs: { width: "90" } }),
          _c("col", { attrs: { width: "70" } }),
          _c("col", { attrs: { width: "95" } })
        ]),
        _c("thead", [
          _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Recette")]),
          _c("th", [_vm._v("Structure")]),
          _c("th", [_vm._v("Date conso.")]),
          _c("th", [_vm._v("Service")]),
          _c("th", [_vm._v("Quantité")]),
          _c("th", [_vm._v("Effectifs")]),
          _c("th", [_vm._v("Date livraison")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", {
        staticClass:
          "col-fixed-width-100-sm col-fixed-width-200-lg col-fixed-width-300-xl"
      }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "70" } }),
      _c("col", { attrs: { width: "90" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "60" } }),
      _c("col", { attrs: { width: "85" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "79" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "60" } }),
      _c("col", { attrs: { width: "85" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "74" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-success ml-3" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(" Validé par le gestionnaire")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }